import React, { useState } from 'react'
import { connect } from 'react-redux'
import to from 'await-catch'
import {
	FormHeader,
	FormTitle,
	InputsContainer,
	ButtonsContainer,
	LinkButton,
	FormContainer,
	Wrapper,
	FormContent
} from '../../ui/form'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import Input from '../../ui/input'
import { Button } from '../../ui/button'
import { hideLoader, showLoader } from '../../../actions'
import { changeEmail } from '../../../api'
import Feedback from '../../feedback'
import { useDebouncedMatchValidation } from '../../../hooks/useDebouncedMatchValidation'

const ChangeUserEmail = ({ auth, dispatch }) => {
	const history = useHistory()
	const [newEmail, setNewEmail] = useState('')
	const [repeatEmail, setRepeatEmail] = useState('')
	const [loading, setLoading] = useState(false)
	const [isChanged, setIsChanged] = useState({ changed: false, error: false })

	const {
		error: repeatEmailError,
		validateMatch: validateRepeatEmail,
		clearError: clearRepeatEmailError
	} = useDebouncedMatchValidation({
		primaryValue: newEmail,
		secondaryValue: repeatEmail,
		requiredMessage: 'Repetí tu nuevo email',
		mismatchMessage: 'Los emails no coinciden'
	})

	const handleSubmit = async e => {
		e.preventDefault()

		if (!validateRepeatEmail({ required: true })) {
			return
		}

		setLoading(true)
		dispatch(showLoader())

		const [err] = await to(changeEmail(auth?.idUsuario, auth?.email, newEmail))

		if (err) {
			setIsChanged({ changed: true, error: true })
			setLoading(false)
			dispatch(hideLoader())
			return
		}

		setIsChanged({ changed: true, error: false })
		setLoading(false)
		dispatch(hideLoader())
	}

	const handleCancel = () => {
		history.push('/inicio/mis-datos')
	}

	return isChanged.changed ? (
		<Feedback
			title={!isChanged.error ? 'Actualizamos tu email' : 'Hubo un error al actualizar tu email'}
			bodyText={
				!isChanged.error
					? 'Enviamos un email de confirmación a tu nueva dirección de correo'
					: 'Por favor volvé a intentarlo más tarde'
			}
			buttonLabel="Volver al inicio"
			onClickButton={handleCancel}
			isError={isChanged.error}
		/>
	) : (
		<Wrapper>
			<form onSubmit={handleSubmit}>
				<FormContainer justifyMobile="center" align="start" margin="0 0">
					<FormHeader align="start">
						<FormTitle>Cambiar email</FormTitle>
					</FormHeader>
					<FormContent>
						<InputsContainer>
							<Input
								fullWidth
								label={'Email actual'}
								placeholder={auth?.email}
								value={auth?.email || ''}
								disabled
							/>
							<Input
								fullWidth
								label={'Nuevo email'}
								placeholder={'Ingresa tu nuevo email'}
								value={newEmail}
								onChange={e => {
									setNewEmail(e.target.value)
									clearRepeatEmailError()
								}}
							/>
							<Input
								fullWidth
								label={'Repetir email'}
								placeholder={'Repetí tu nuevo email'}
								value={repeatEmail}
								error={repeatEmailError}
								onChange={e => {
									setRepeatEmail(e.target.value)
									clearRepeatEmailError()
								}}
							/>
						</InputsContainer>
						<ButtonsContainer>
							<Button
								label={'Guardar cambios'}
								$variant="primary"
								size="mobile"
								type="submit"
								disabled={loading}
							/>
							<LinkButton type="button" onClick={handleCancel}>
								Cancelar
							</LinkButton>
						</ButtonsContainer>
					</FormContent>
				</FormContainer>
			</form>
		</Wrapper>
	)
}
const mapStateToProps = (state = {}) => ({
	auth: state.auth || {},
	patient: state.patient || {}
})
export default connect(mapStateToProps)(ChangeUserEmail)
